"use client";
import { Loader, Lock, LogOut, UserRound } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { CaretSortIcon } from "@radix-ui/react-icons";
import { useDispatch } from "react-redux";
import { logout } from "@/store/slices/authSlice";
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { User } from "@/views/modules/user-management/users/types/userType";
import { useLogout } from "@/views/authentication/hooks/authHooks";

export function NavUser({
  user,
  handleIsResetOpen,
}: {
  user: User | null,
  handleIsResetOpen: (isOpen: boolean) => void;
}) {
  const { isMobile } = useSidebar();
  const { t } = useTranslation()
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const { refetch: getLogout, isLoading } = useLogout({
    enableCondition: false,
    onSuccessFn: ()=> {
      dispatch(logout());
      window.location.href = "/auth/login";
      // navigate("/auth/login");
    }
})

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="h-8 w-8 rounded-lg">
                <AvatarFallback className="rounded-lg">
                  <UserRound className="!text-primary-foreground" />
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 ltr:text-left rtl:text-right text-sm leading-tight">
                <span className="truncate font-semibold capitalize">{user?.fullName}</span>
                <span className="truncate text-xs">{user?.email}</span>
              </div>
              <CaretSortIcon className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 ltr:text-left rtl:text-right text-sm">
                <Avatar className="h-10 w-10 rounded-lg">
                  <AvatarFallback className="rounded-lg">
                    <UserRound />
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 ltr:text-left rtl:text-right text-sm leading-tight">
                  <span className="truncate font-semibold capitalize">{user?.fullName}</span>
                  <span className="truncate text-xs">{user?.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem
                className="!cursor-pointer"
                onClick={() => {
                  handleIsResetOpen(true)
                }}>
                <Lock />
                {t("reset_password")}
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="!cursor-pointer"
              onClick={() => {
                getLogout()
              }}
            >
              <LogOut />
              {t("logout")}
              {isLoading && <Loader className="w-4 h-4 animate-spin" />}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
